import { getActivePinia } from "pinia";

export const clearAllStores = async () => {
  const stores = getActivePinia()._s;
  console.log(`Resetting ${stores.size} stores`);

  const futures = [];

  stores.forEach(e => futures.push(clearStore(e)));

  await Promise.all(futures);
};

export const clearStore = async store => {
  // await store?.$reset?.(); // might not be necessary as we're disposing and deleting the store
  store.$dispose();
  const pinia = getActivePinia();
  delete pinia.state.value[store.$id];
};
